import { useEffect, useState, useContext, useRef} from 'react'
import { Link, useLocation, useParams } from "react-router-dom";


import './css/Cp.css'
import { AppContext } from "../Context";
import Fetch, { Loader, dateToText } from "../inc/Fetch";

import Footer from "./Footer";
import Header from "./Header";
import SendTask from "./popups/SendTask";

import { RiQuestionAnswerLine } from "react-icons/ri";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { MdDeleteOutline, MdEdit, MdOutlineGroup } from "react-icons/md";


export default function StudentTasks() {

	const {success, userinfo, languageText} = useContext(AppContext);
	const [open, setopen] = success;
	const [logedIn, setlogedIn] = userinfo;
	const [text, settext] = languageText;

	const [loader, setloader] = useState(true);
	const [data, setdata] = useState([]);
	const [showsendTask, setshowsendTask] = useState(false); 

	let loc = useParams();

	useEffect(() => {
		

		Fetch("tasks/view", (d) => {

			if (d?.error) {
				setopen({
                    title:text?.alertErrorTitle,
                    short:d?.error,
                    error:true
                });
			} else {
				setdata(d);
			}

			setloader(false);
		});


	}, []);


	
	if (loader) {
		return (
			<Loader />
		);
	}


	return (
		<>
			<Header  />
			<div className='firstElem stats'>

				<div className='mainWidth'>


					<section>
						<div>
							<b>عدد المهام الحوسبة</b>
							<h3>{data?.stats?.tasks}</h3>
							{/* <span className='up'><FaArrowUp /> 10.3%</span> */}
						</div>
					</section>

					<section>
						<div>
							<b>مهام محوسبة لم اقم بحلها</b>
							<h3>{data?.stats?.notFinished}</h3>
							{/* <span className='up'><FaArrowUp /> 10.3%</span> */}
						</div>
					</section>

					<section>
						<div>
							<b>معدل علامات المهام المحوسبة</b>
							<h3>{data?.stats?.avg}%</h3>
							{/* <span><FaArrowDown /> 2.3%</span> */}
						</div>
					</section>


					


				</div>
			</div>


			<div className='body'>
				<div className='mainWidth '>

					<div className='cp'>



						<div className='containerBox' style={{flex:1, }}>
					
							<div className='quizzesList'>
								<table>
									<thead>
										<tr>
											<td style={{width:"60%"}} className='align-left'>اسم المهمة</td>
											<td >عدد الاسئلة</td>
											<td>العلامة</td>
											<td>التوقيت</td>
											<td>الحالة</td>
										</tr>
									</thead>
									
									<tbody>
										{data?.tasks?.map((v, k) => {

											
											return (
												<tr className={!v?.st_score && !v?.st_finished && `checked`} key={k}>
													<td className='align-left'><Link to={v?.st_finished ? `` : `/TaskStart/${v?._id}`}><b>{v?.name}</b> {v?.full && <><br /><p>{v?.full}</p></>}</Link></td>
													<td>{v?.questions?.length}</td>
													<td>{v?.st_finished && v?.st_score ? <span className={`tag ${v?.st_score <= 50 ? "red" : "green"}`}>{v?.st_score}%</span> : "--"}</td>
										
													<td>
														{v?.st_timer ? <span className='tag'>{v?.st_timer}</span> : "--"}
													</td>
													<td>
														{v?.st_score && v?.st_finished ? <span className={`tag green`}>علامة نهائية</span>: false}
														{v?.st_score && !v?.st_finished ? <span className='tag orange'>بانتظار التصليح..</span>: false}
														{!v?.st_score && !v?.st_finished ? <span className='tag gray'>لم تبدأ بعد</span>: false}
													</td>
												
												</tr>
											);
										})}
										
									</tbody>
								</table>
							</div>
							
						</div>
					</div>


						
					
					
				</div>


			</div>

			<Footer />
		</>
	);
		
	
}
